<template>
	<div
		:class="cn('text-sm [&_p]:leading-relaxed', props.class)"
		v-bind="$attrs"
	>
		<slot />
	</div>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';

const props = defineProps<{
	class?: string;
}>();
</script>
